import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";
import { setAlert } from "./alert.slice";
import { BASE_URL } from "../../utils/baseURL";
import Cookies from 'js-cookie';
import { addLiasoning } from "./liasoning.slice";

const initialState = {
    Marketing: [],
    success: false,
    message: '',
    loading: false,
};

const handleErrors = (error, dispatch, rejectWithValue) => {
    const errorMessage = error.response?.data?.message || 'An error occurred';
    dispatch(setAlert({ text: errorMessage, color: 'error' }));
    return rejectWithValue(error.response?.data || { message: errorMessage });
};



export const getCommercialMarketing = createAsyncThunk(
    'commercialMarketing/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getAllCommercialMarket', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            // console.log(response.data, "getcommercialMarketing");
            return response.data.commercialMarket;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const addCommercialMarketing = createAsyncThunk(
    'commercialMarketing/add',
    async (data, { dispatch, rejectWithValue }) => {
        // console.log(data);
        try {
            const { dealerImage, MultipleDetails, Dealer, ...rest } = data;
            const formData = new FormData();

            formData.append('MultipleDetails', JSON.stringify(MultipleDetails));

            formData.append('Dealer', Dealer && Dealer !== "null" ? Dealer : null);

            Object.keys(rest).forEach(key => {
                if (Array.isArray(rest[key])) {
                    rest[key].forEach(item => {
                        formData.append(key, item);
                    });
                } else {
                    formData.append(key, rest[key]);
                }
            });

            if (dealerImage) {
                dealerImage.forEach((file, index) => {
                    if (file instanceof File) {
                        formData.append('dealerImage', file);
                        formData.append(`dealerImageIndex_${formData.getAll('dealerImage').length - 1}`, index);
                    } else if (typeof file === 'string') {
                        formData.append(`ExistingdealerImage_${index}`, file);
                    }
                });
            }

            const response = await axiosInstance.post(BASE_URL + '/createCommercialMarket', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                },
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            if (response.data.commercialMarketing) {
                // console.log("response.data.commercialMarketing", response.data)
                dispatch(addLiasoning({ ...response.data.commercialMarketing, marketId: response.data.commercialMarketing._id, status: "Disabled" }));
            } else if (response.data.residentialMarketing) {
                // console.log("response.data.residentialMarketing", response.data)
                dispatch(addLiasoning({ ...response.data.residentialMarketing, marketId: response.data.residentialMarketing._id, status: "Disabled" }));
            }
            dispatch(getCommercialMarketing());
            return response.data.commercialMarket;
        } catch (error) {
            console.log("Error occurred:", error);
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const deleteCommercialMarketing = createAsyncThunk(
    'commercialMarketing/delete',
    async (id, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.delete(BASE_URL + `/deleteCommercial/${id}`, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            return id;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);
export const viewComerialMarketing = createAsyncThunk(
    'commercialMarketing/view',
    async (id, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`${BASE_URL}/getCommercialMarket/${id}`, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            // console.log("response>>>>>",response.data.CommercialMarket);
            return response.data;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);


export const editCommercialMarketing = createAsyncThunk(
    'commercialMarketing/edit',
    async (data, { dispatch, rejectWithValue }) => {
        try {
            const { id, dealerImage, MultipleDetails, Dealer, ...rest } = data;
            // console.log("id>>>>>>>", id);
            console.log("data>>>>>>>", data);
            const formData = new FormData();

            formData.append('MultipleDetails', JSON.stringify(MultipleDetails));
            if (Dealer && Dealer !== "null") {
                formData.append('Dealer', Dealer);
            } else {
                formData.append('Dealer', null);
            }

            Object.keys(rest).forEach(key => {
                if (Array.isArray(rest[key])) {
                    rest[key].forEach(item => {
                        formData.append(key, item);
                    });
                } else {
                    formData.append(key, rest[key]);
                }
            });

            if (dealerImage) {
                dealerImage.forEach((file, index) => {
                    if (file instanceof File) {
                        // New file
                        formData.append('dealerImage', file);
                        formData.append(`dealerImageIndex_${formData.getAll('dealerImage').length - 1}`, index);
                    } else if (typeof file === 'string') {
                        // Existing file path
                        formData.append(`ExistingdealerImage_${index}`, file);
                    }
                });
            }

            const response = await axiosInstance.put(`${BASE_URL}/updateCommercial/${id}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                },
            });

            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            // console.log(response.data);
            dispatch(getCommercialMarketing());
            return response.data.commercialMarket;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getAllWarehouse = createAsyncThunk(
    'commercialMarketing/getAllWarehouse',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getAllCommercialWarehouse', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.warehouseUsers;

        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getAllCommercialProduct = createAsyncThunk(
    'commercialMarketing/getAllCommercialProduct',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getAllCommercialProduct', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.allProducts;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);



export const getAllCommercialDealer = createAsyncThunk(
    'commercialMarketing/getAllCommercialDealer',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getAllCommercialDealer', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.dealers;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);
export const getAllDealerProduct = createAsyncThunk(
    'commercialMarketing/getAllDealerProduct',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getDealerData', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });

            return response.data.dealerProduct;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getAllPendingDealer = createAsyncThunk(
    'commercialMarketing/allPendingDealerData',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/allPendingDealerData', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });

            return response.data.pendingDealer;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

const CommercialMarketingSlice = createSlice({
    name: 'commercialMarketing',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Get commercial Market
            .addCase(getCommercialMarketing.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Commercial Marketing...';
            })
            .addCase(getCommercialMarketing.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'Commercial Marketing fetched successfully';
                state.Marketing = action.payload;
            })
            .addCase(getCommercialMarketing.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
            })
            // Add commercial Market
            .addCase(addCommercialMarketing.pending, (state) => {
                state.loading = true;
                state.message = 'Adding category...';
            })
            .addCase(addCommercialMarketing.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.Marketing.push(action.payload);
                state.message = action.payload?.message || 'Commercial Marketing added successfully';
            })
            .addCase(addCommercialMarketing.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to add Commercial Marketing';
            })
            // Delete commercial Market
            .addCase(deleteCommercialMarketing.pending, (state) => {
                state.loading = true;
                state.message = 'Deleting Commercial Marketing...';
            })
            .addCase(deleteCommercialMarketing.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.Marketing = state.Marketing.filter((v) => v._id !== action.payload);
                state.message = action.payload?.message || 'Commercial Marketing deleted successfully';
            })
            .addCase(deleteCommercialMarketing.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to delete Commercial Marketing';
            })
            // Edit commercial Market
            .addCase(editCommercialMarketing.pending, (state) => {
                state.loading = true;
                state.message = 'Editing Commercial Marketing...';
            })
            .addCase(editCommercialMarketing.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                if (Array.isArray(state.Marketing)) {
                    state.Marketing = state.Marketing.map((v) =>
                        v?._id === action.payload?._id ? action.payload : v
                    );
                }
                state.message = action.payload?.message || 'Commercial Marketing updated successfully';
            })
            .addCase(editCommercialMarketing.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to update Commercial Marketing';
            })
            //view single commercial Market 
            .addCase(viewComerialMarketing.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Commercial Market...';
            })
            .addCase(viewComerialMarketing.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'commercial Market fetched successfully';
                state.Marketing = Array.isArray(action.payload.data) ? action.payload.data : [];
            })
            .addCase(viewComerialMarketing.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch commercial Market';
            })
            // Get all warehouse
            .addCase(getAllWarehouse.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Warehouse...';
            })
            .addCase(getAllWarehouse.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'Warehouse fetched successfully';
                state.warehouseUsers = action.payload;
            })
            .addCase(getAllWarehouse.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Warehouse';
            })
            // Get all Commercial Product
            .addCase(getAllCommercialProduct.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Commercial Product...';
            })
            .addCase(getAllCommercialProduct.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'Commercial Product fetched successfully';
                state.allProducts = action.payload;
            })
            .addCase(getAllCommercialProduct.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Commercial Product';
            })
            // Get all Commercial Dealer
            .addCase(getAllCommercialDealer.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Commercial Dealer...';
            })
            .addCase(getAllCommercialDealer.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'Commercial Dealer fetched successfully';
                state.dealers = action.payload;
            })
            .addCase(getAllCommercialDealer.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Commercial Dealer';
            })
            // Get all Dealer Product
            .addCase(getAllDealerProduct.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Dealer Product...';
            })
            .addCase(getAllDealerProduct.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'Dealer Product fetched successfully';
                state.dealerProduct = action.payload;
            })
            .addCase(getAllDealerProduct.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Dealer Product';
            })
            // Get all pending Dealer
            .addCase(getAllPendingDealer.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Warehouse...';
            })
            .addCase(getAllPendingDealer.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'Warehouse fetched successfully';
                state.pendingDealer = action.payload;
            })
            .addCase(getAllPendingDealer.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Warehouse';
            })
    }
});

export default CommercialMarketingSlice.reducer;